const ProductTypeConstant = {
  MACHINE: 'MACHINE',
  BATTERY: 'BATTERY',
  CHARGER: 'CHARGER',
  PRODUCT: 'PRODUCT',
  ACCESSORY_ONE: 'ACCESSORY_ONE',
  ACCESSORY_TWO: 'ACCESSORY_TWO',
  BRIEFCASE: 'BRIEFCASE',
  PREMIUM_CONSUMABLE: 'PREMIUM_CONSUMABLE',
  PPE: 'PPE',
  EQUIPMENT: 'EQUIPMENT',
  PALLET: 'PALLET'
}

export default ProductTypeConstant